import { BehaviorSubject } from 'rxjs';
import { useState, useEffect } from 'react';
import * as appRoles from './applicationRoles';

// once the applications have an access token, they can make requests to
// Alli Central's `/me` endpoint to get information about the current user
// those results are stored here.
export const currentUser = new BehaviorSubject(null);

function noop(user) {
    return user;
}

function mapToId(inputArray) {
    const outObject = {};
    (inputArray || []).forEach(item => {
        outObject[item.id] = item;
    });

    return outObject;
}

function transformUser(user, transformer) {
    if (!user) {
        return null;
    }

    user.applicationMap = mapToId(user.applications);
    user.clientMap = mapToId(user.clients);
    user.partnerMap = mapToId(user.partners);

    return transformer(user);
}

export function appUserPermissionTransformer(applicationId) {
    return user => ({
        ...user,
        isUser: appRoles.isGranted(applicationId, appRoles.USER, user),
        isPowerUser: appRoles.isGranted(applicationId, appRoles.POWER, user),
        isAdmin: appRoles.isGranted(applicationId, appRoles.ADMIN, user),
    });
}

/**
 * Should an an application need to access the current user, this is the hook
 * to do so.
 *
 * @param function transformer an optional function to manipulate the user before it goes into state
 */
export function useCurrentUser(transformer = noop) {
    const [user, setUser] = useState(
        transformUser(currentUser.getValue(), transformer),
    );

    useEffect(() => {
        const observer = currentUser.subscribe(user =>
            setUser(transformUser(user, transformer)),
        );
        return () => observer.unsubscribe();
    }, [setUser, transformer]);

    return user;
}
